/**
 * Fait : l'avertissement de `D-029`, lu au moment de créer son compte, AVANT
 *   de choisir son mot de passe. Le texte est celui que Charles a retenu après
 *   comparaison de deux tons, mot pour mot — il ne se reformule pas.
 *
 *   Pourquoi il existe : Clannik tourne sur une machine qui appartient à
 *   Charles. Aucun écran ne donne à quiconque la lecture de ce qui ne lui est
 *   pas partagé (`D-033`, première moitié) — mais qui détient la machine peut
 *   techniquement tout lire. Ce fait est DÉCLARÉ plutôt que tu : ce qui protège
 *   les proches n'est pas le logiciel, c'est une parole donnée, et chacun
 *   choisit en connaissance de cause au lieu qu'on lui vende une
 *   confidentialité qui n'existe pas.
 *
 * Ne fait pas : il ne demande aucun accord, ne pose aucune case à cocher et ne
 *   bloque rien. Une case à cocher transformerait une parole en formalité
 *   qu'on expédie sans lire.
 */

import { Partie } from '../gabarits/Partie.tsx';

export function PromesseDeClannik() {
  return (
    <Partie
      etiquette="À lire avant"
      nature="partage"
      titre="Ce que Clannik promet, et ce qu’il ne peut pas promettre"
      niveauDeTitre={2}
      data-role="promesse"
    >
      <p>
        Clannik n’ouvre tes projets à personne que tu n’as pas invité — ni aux autres membres, ni à
        Charles. Aucun écran ne le permet.
      </p>
      <p>
        Mais Clannik tourne sur une machine qui appartient à Charles, et tes textes y sont rangés en
        clair. Qui détient la machine peut, techniquement, tout lire : Charles, et l’assistant qui
        l’aide à réparer l’application quand elle tombe en panne.
      </p>
      <p>
        Ce n’est donc pas un verrou qui te protège, c’est une parole. Charles s’engage à ne pas
        aller lire ce qui ne lui est pas partagé, et à te prévenir s’il devait le faire pour réparer
        quelque chose.
      </p>
      <p data-role="promesse-derniere-phrase">
        Si cette parole ne te suffit pas, n’écris pas dans Clannik ce que tu ne confierais pas à
        Charles.
      </p>
    </Partie>
  );
}
